export default {
  settingLogisticsStrategyConfig: {
    orderAmount: '订单满足一定金额指定物流',
    district: '收货地址指定省市区指定物流',
    storehouse: '指定仓库指定物流',
    goods: '指定商品指定物流',
    logisticsStrategy: '物流策略',
    logisticsStrategyText: '可拖动规则进行排序，前面的优先级高',
    setOrderAmount: '设置订单金额',
    setProvinces: '设置省市区',
    setWarehouse: '设置仓库',
    designatedProduct: '设置指定商品',
    logisticsSettings: '物流设置',
    freightRadio: '按运费最低优先',
    priorityRadio: '按优先级高优先',
    defaultLogistics: '默认物流',
    defaultLogisticsText: '默认可通用的物流，物流匹配失败后备用',
    table: {
      packageBilling: '包裹计费',
      packageBillingRules: '请输入包裹计费',
      businessName: '业务名称',
      businessNameRules: '请选择业务名称',
      logisticsProviderName: '物流商名称',
      logisticsProviderNameRules: '请选择物流商名称',
    },
    selectDesignatedLogisticsBusiness: '请选择指定物流业务',
    selectDesignatedLogisticsProvider: '请选择指定物流商',
    pricePackage: '元/包裹',
    confirmText: '是否保存当前操作？'
}
};
